import { Injectable } from '@angular/core';
import {RequestService} from "../request/request.service";
import {UtilService} from "../util/util.service";
import {UserService} from "../user/user.service";

export type TableMetadataKeyValue = {
  i18nKey: string;
  value: string;
};

export type TableMetadataKeyObject = {
  [key: string]: any;
};

@Injectable({
  providedIn: 'root'
})
export class TableMetadataService {

  private metadataLoaded = false;

  private tables: TableMetadataKeyValue[];
  private fieldTypes: TableMetadataKeyObject;
  private javascriptRenderers: TableMetadataKeyValue[];
  private reservedFieldNames: string[];
  private fieldToRendererMappings: TableMetadataKeyObject;
  private fieldValueTypes: TableMetadataKeyValue[];
  private applications: any[];

  constructor(private requestService: RequestService, private utilService: UtilService, private userService: UserService) { }

  async init() {
    if (!this.metadataLoaded) {
      if (this.userService.isAuthenticated()) {
        this.metadataLoaded = true;

        const result: any = await this.requestService.createRequest()
          .controller('servicely.core.ApplicationBuilder')
          .method('tableMetadata')
          .execute();

        const data: any = result.data;

        this.tables = data.tableList;
        this.fieldTypes = data.allFieldTypes;
        this.javascriptRenderers = data.allJavaScriptRenderers;
        this.reservedFieldNames = data.allReservedFieldNames;
        this.fieldToRendererMappings = data.allFieldToRendererMappings;
        this.fieldValueTypes = data.allFieldValueTypes;
        this.applications = data.allApplications;
      }
    }
  }

  allTables(): TableMetadataKeyValue[] {
    return this.tables;
  }

  allFieldTypes(): TableMetadataKeyObject {
    return this.fieldTypes;
  }

  allJavaScriptRenderers(): TableMetadataKeyValue[] {
    return this.javascriptRenderers;
  }

  allReservedFieldNames(): string[] {
    return this.reservedFieldNames;
  }

  allFieldToRendererMappings(): TableMetadataKeyObject {
    return this.fieldToRendererMappings;
  }

  allFieldValueTypes(): TableMetadataKeyValue[] {
    return this.fieldValueTypes;
  }

  allApplications(): any[] {
    return this.applications;
  }
}
